import * as classnames from 'classnames'
import * as React from 'react'
import { Link } from 'react-router-dom'
import { getSrcSetData } from '../../itemCard/photoduneGridItemCard/imgUrls'
import * as styles from './similarPhotos.module.css'

interface IProps {
  item: any
  selected: any
  onItemClick: (event: any, item: any) => void
}

interface IDefaultImage {
  url: string
}

interface ISrcSetData {
  defaultImage: IDefaultImage
  srcSet: string
  sizes: string
}

const SimilarPhoto: React.StatelessComponent<IProps> = props => {
  const { item, onItemClick, selected } = props

  const c200 = getSrcSetData(item.image_urls, 'c200') as ISrcSetData
  const c300 = getSrcSetData(item.image_urls, 'c300') as ISrcSetData

  const similarPhotoStyles = classnames(styles.similarPhoto, {
    [styles.selectedPhoto]: selected
  })

  return (
    <div className={similarPhotoStyles}>
      <Link
        className={styles.photoWrapper}
        to={item.url}
        onClick={event => onItemClick(event, item)}
      >
        <img
          alt={item.name}
          srcSet={`${c300.defaultImage.url} 2x`}
          src={c200.defaultImage.url}
          title={item.name}
          className={styles.photo}
        />
      </Link>
    </div>
  )
}

export default SimilarPhoto
